@if(drilldown()) {
  <app-crypto-token-details [value]="drilldown()" (back)="onBack()"></app-crypto-token-details>
} 
<!-- @else if(edit()) {
  <app-cryptokenlist [value]="edit()" [saving]="saving()" (save)="onSave($event)" (cancelEdit)="onCancel($event)"></app-cryptokenlist>
}  -->
@else {
  <app-cryptotokenlist-main-table></app-cryptotokenlist-main-table>
}
